import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { useLaunch } from '../contexts/LaunchContext';
const features = ['Unlimited kitties for every group', 'Friends can join from their browser', 'Invite by link, code, QR or contacts', 'Equal or custom splits on any spend', 'Receipts attached to the expense', 'Nudges, settle-up and confirmation', 'My Balance across every kitty'];
export function Pricing() {
  const {
    isPublicLaunch
  } = useLaunch();
  const scrollToCta = () => document.getElementById('get-started')?.scrollIntoView({
    behavior: 'smooth'
  });
  return <section id="pricing" className="py-28 lg:py-36 bg-gray-50" data-id="element-237" data-mp="25q4u5rs35ggw">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-238" data-mp="20sd4l4ewy6fv">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="text-center max-w-2xl mx-auto mb-16" data-id="element-239" data-mp="3h74o0ru303d1">
          <h2 className="text-3xl md:text-5xl font-black text-kitty-dark mb-4 tracking-tight" data-id="element-240" data-mp="3w1jfy2f7wjyu">
            {isPublicLaunch ? 'Free to download.' : 'Free during early access.'}
          </h2>
          <p className="text-lg text-gray-500 max-w-lg mx-auto" data-id="element-241" data-mp="9t0g5qwqshod">
            Get started free. Unlimited kitties, unlimited members, no
            subscription.
          </p>
        </motion.div>

        <div className="max-w-lg mx-auto" data-id="element-242" data-mp="3dasavd29jfq9">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-[2rem] p-8 md:p-12 shadow-card border border-gray-100 relative overflow-hidden" data-id="element-243" data-mp="3i7iq5y68u7am">
            {/* Yellow top accent line */}
            <div className="absolute top-0 left-0 right-0 h-1.5 bg-kitty-yellow" data-id="element-244" data-mp="2zhkkfopx4qa5" />

            <div className="text-center mb-10 mt-2" data-id="element-245" data-mp="2zfg4g8eqw0ti">
              <p className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-green-50 text-green-700 text-sm font-medium mb-4" data-id="element-246" data-mp="2rftdidf81ngp">
                <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-247" data-mp="2mfp6rf44873o" />
                {isPublicLaunch ? 'No subscription' : 'Early access pricing'}
              </p>
              <div className="flex items-baseline justify-center gap-2" data-id="element-248" data-mp="2w8mi91aowvss">
                <span className="text-6xl md:text-7xl font-black text-kitty-dark" data-id="element-249" data-mp="28hh20l0u81hy">
                  £0
                </span>
              </div>
            </div>

            <ul className="space-y-4 mb-10" data-id="element-250" data-mp="23l0he0suk59m">
              {features.map(feature => <li key={feature} className="flex items-center gap-3" data-id="element-251" data-mp="2ihhmiaag0nnq">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 flex items-center justify-center" data-id="element-252" data-mp="2dgah2hvrw0k8">
                    <CheckIcon className="w-3.5 h-3.5 text-green-700" aria-hidden="true" data-id="element-253" data-mp="3ttihw81tbacg" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-254" data-mp="9cburhpfh3x">{feature}</span>
                </li>)}
            </ul>

            <button onClick={scrollToCta} className="w-full bg-kitty-yellow hover:bg-kitty-yellow-500 text-kitty-dark py-4 rounded-full font-bold text-lg transition-colors duration-150 active:scale-[0.98] shadow-md hover:shadow-lg flex items-center justify-center gap-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-dark" data-id="element-255" data-mp="57dq8z46qs92">
              {isPublicLaunch ? 'Get KittyPot' : 'Join the waitlist'}
              <ArrowRightIcon className="w-5 h-5" aria-hidden="true" data-id="element-256" data-mp="a9cuscbnvv7l" />
            </button>

            {!isPublicLaunch && <p className="text-center text-xs text-gray-500 mt-5 font-medium" data-id="element-257" data-mp="e8lppkiftz4q">
                🚀 Limited spots, join early access now
              </p>}
          </motion.div>
        </div>
      </div>
    </section>;
}